import * as actionType from "./actionTypes";
import { getRequest, postRequest, processError } from "../../utils/apiHandlers";
import { LOADING_STATE, LS_ITEM, NOTIF_TYPE } from "../../utils/stateTypes";
import _notif from "../notification";
import { catalogueSelectors } from "../rootSelectors";
import { savePricingPrefs } from "../localStorage";

//Remembers rand / dollars and monthly / annual
export const setPricingPrefs = (prefs) => (
  (dispatch, getState) => {
    dispatch({ type: actionType.SET_PRICING_PREFS, prefs });
    const state = getState();
    savePricingPrefs({ currency: catalogueSelectors.getCurrency(state), interval: catalogueSelectors.getInterval(state) });
  }
);

export const loadPlans = (force=false) => (
  (dispatch, getState) => {
    if (!force && catalogueSelectors.getPlans(getState()) !== null) {
      return;
    }
    const lsItem = LS_ITEM.PLANS;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    getRequest("/Public/Plans",
      (plans) => {
        dispatch({ type: actionType.SET_PLANS, plans });
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);

export const subscribeNewsletter = (email, consent, successCB) => (
  (dispatch) => {
    const lsItem = LS_ITEM.NEWSLETTER;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    postRequest("/Public/Newsletter",
      { email, consent },
      () => {
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
        dispatch(_notif.actions.queueNotification("You're on the list - thanks for signing up!", NOTIF_TYPE.SUCCESS));
        successCB();
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);
